import { useCallback } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useNavigate } from "react-router-dom";

export const AskedQuestions = ({ faqListData = [] }) => {
  const navigate = useNavigate();
  const formatCategoryForUrl = useCallback((value = "") => {
    return value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }, []);

  const handleTabChange = (e) => {
    const selectedIndex = e?.index;
    if (
      selectedIndex === undefined ||
      !Array.isArray(faqListData) ||
      !faqListData[selectedIndex]
    ) {
      return;
    }
    const selectedItem = faqListData[selectedIndex];
    const formattedCategory = formatCategoryForUrl(selectedItem?.contentTitle);
    navigate(`/VZYSupport/details/${formattedCategory || "not-found"}`, {
      state: {
        detailsIDs: selectedItem,
      },
    });
  };

  if (!Array.isArray(faqListData) || faqListData.length === 0) {
    return (
      <div className="no-record-found">
        <p className="text-center">No frequently asked questions found.</p>
      </div>
    );
  }

  return (
    <Accordion onTabChange={handleTabChange}>
      {faqListData.map((item, index) => (
        <AccordionTab
          key={item?.contentID ?? index}
          header={item?.contentTitle || "-"}
        >
          <p className="m-0">{item?.contentTitle || "-"}</p>
        </AccordionTab>
      ))}
    </Accordion>
  );
};
